import React from 'react';
import { Box } from '@chakra-ui/react';
import Typewriter from 'typewriter-effect';

const TypewriterMessage = () => {
    return (
        <Box 
            color="gray.300" 
            fontSize="lg"
            textAlign="center"
            mt={2}
            minH="32px" // Add minimum height to prevent layout shift
        >
            <Typewriter
                options={{
                    strings: [
                        '🖼️✨ Get whitelist NFT → 🔗 Connect Wallet → 🏦 Reserve Jinu → 📥 Claim → 🔄 Trade → 📊 Stake → 🎮 Play!',
                    ],
                    autoStart: true,
                    loop: true,
                    delay: 50,
                    deleteSpeed: 30,
                    pauseFor: 2000,
                    cursor: '|',
                }}
            />
        </Box>
    );
};

export default TypewriterMessage;
